module.exports = function () {
  return Object.assign
}
